'use client'

import {SLinkButton} from "@/components/atoms/button";
import {Section} from "@/components/atoms/sections";
import {Edito} from "@/components/molecules/edito";
import classNames from "classnames";

export const AboutLodging = () => {
  return <Edito className={classNames('md:col-12')}
                icon={'lodging'}
                title={'Annonces de location'}
                description={'Publiez vos annonces de locations'}>
    <div className={'flex justify-content-center'}>
      <SLinkButton href={"/my-lodgings"}>Publier votre annonce</SLinkButton>
    </div>
  </Edito>
}


export const AboutPricing = () => {
  return <Edito className={classNames('md:col-12')}
                icon={'handshake'}
                title={'Aucun frais caché'}
                description={'Profitez gratuitement des services, payez uniquement des options à la demande.'}>
    <div className={'flex justify-content-center'}>
      <SLinkButton href={"/pages/pricing"}>Voir les options</SLinkButton>
    </div>
  </Edito>
}

export const AboutSection = () => {

  return <Section>

    {/*<AboutLodging/>*/}
    {/*<AboutPage/>*/}
    {/*<AboutPricing/>*/}


    {/*<Edito className={classNames('md:col-12')}*/}
    {/*       icon={'account-confirmed'}*/}
    {/*       title={'Devenez guide'}*/}
    {/*       placeholder={'Publiez vos voyages et vos bon plans et gagnez en reconnaissance'}>*/}
    {/*  <div className={'flex justify-content-center'}>*/}
    {/*    <SLinkButton href={"/new-announce"}>Publier mes voyages</SLinkButton>*/}
    {/*  </div>*/}
    {/*</Edito>*/}


  </Section>

}
